import IGlassWallDoor from 'components/interfaces/IGlassWallDoor';
import IWall from 'components/interfaces/IWall';
import translations from 'services/translations/translations';
import getOptions from '../services/getOptions';
import doorHangTypes from './doorHangTypes';
import doorLeafDirectionTypes from './doorLeafDirectionTypes';
import doorSideTypes from './doorSideTypes';
import woodyDoorHeightOptions from './woodyDoorHeightOptions';
import woodyDoorThresholdOptions from './woodyDoorThresholdOptions';
import woodyHingeTypes from './woodyHingeTypes';
import glazyDoubleWidthTypes from './glazyDoubleWidthTypes';
import glazyDoubleGlassTypes from './glazyDoubleGlassTypes';
import positionOnWallTypes from './positionOnWallTypes';
import doorTypes, { NO_DOOR, NO_DOOR_GLASS_AROUND } from './doorTypes';
import handleTypes from './handleTypes';
import thresholdTypes from './thresholdTypes';
import {
  getFirstDoorVerticalProfileTypes,
  getMiddleDoorVerticalProfileTypes,
} from './verticalProfileTypes';

export const doorOptions = (
  includes?: string[],
  excludes?: string[]
): JSX.Element[] => {
  let types: string[] = [];

  if (includes === undefined) {
    // Default all
    return getOptions(
      doorTypes,
      translations.glassWallDoorProperties,
      'doorTypes'
    );
  }

  includes.forEach((include) => {
    const valuesToAdd = doorTypes.filter((type) => type.includes(include));
    types.push(...valuesToAdd);
  });

  if (excludes !== undefined) {
    excludes.forEach((exclude) => {
      types = types.filter((type) => !type.includes(exclude));
    });
  }
  let options = getOptions(
    types.filter(onlyUnique),
    translations.glassWallDoorProperties,
    'doorTypes'
  );

  // Global values
  options = options.concat(
    getOptions(
      [NO_DOOR, NO_DOOR_GLASS_AROUND],
      translations.glassWallDoorProperties,
      'doorTypes'
    )
  );
  return options;
};

function onlyUnique(value: string, index: number, self: string[]) {
  return self.indexOf(value) === index;
}

export const doorSideOptions = (): JSX.Element[] =>
  getOptions(
    doorSideTypes,
    translations.glassWallDoorProperties,
    'doorSideTypes'
  );

export const doorHangOptions = (): JSX.Element[] =>
  getOptions(
    doorHangTypes,
    translations.glassWallDoorProperties,
    'doorHangTypes'
  );

export const verticalProfileOptions = (
  side: string,
  updatedWall: IWall | null
): JSX.Element[] => {
  if (updatedWall === null) {
    return getOptions(
      ['-'],
      `${translations.glassWallProperties}`,
      'verticalProfileTypes'
    );
  }

  let options;

  const middleDoorVerticalProfileTypes =
    getMiddleDoorVerticalProfileTypes(updatedWall);

  if (updatedWall.parts.length !== 0) {
    const firstDoor = updatedWall.parts[0] as IGlassWallDoor;

    const lastDoor = updatedWall.parts[
      updatedWall.parts.length - 1
    ] as IGlassWallDoor;

    const checked =
      side === 'left' ? firstDoor.isFirstDoor : lastDoor.isLastDoor;

    const firstDoorVerticalProfileTypes = getFirstDoorVerticalProfileTypes(
      updatedWall.glazingWallType
    );

    options = checked
      ? firstDoorVerticalProfileTypes
      : middleDoorVerticalProfileTypes;
  } else {
    options = middleDoorVerticalProfileTypes;
  }

  return getOptions(
    options,
    `${translations.glassWallProperties}`,
    'verticalProfileTypes'
  );
};

export const doorGlassOptions = (types: any): JSX.Element[] =>
  getOptions(types, translations.glassWallDoorProperties, 'glassTypes');

export const handleTypeOptions = (): JSX.Element[] =>
  getOptions(handleTypes, translations.glassWallDoorProperties, 'handleTypes');

export const doorLeafDirectionOptions = (): JSX.Element[] =>
  getOptions(
    doorLeafDirectionTypes,
    translations.glassWallDoorProperties,
    'doorLeafDirectionTypes'
  );

export const glazyDoubleWidthOptions = (): JSX.Element[] =>
  getOptions(
    glazyDoubleWidthTypes,
    translations.glassWallDoorProperties,
    'glazyDoubleWidthTypes'
  );

export const glazyDoubleGlassOptions = (): JSX.Element[] =>
  getOptions(
    glazyDoubleGlassTypes,
    translations.glassWallDoorProperties,
    'glazyDoubleGlassTypes'
  );

export const postionOnWallOptions = (): JSX.Element[] =>
  getOptions(
    positionOnWallTypes,
    translations.glassWallDoorProperties,
    'positionOnWallTypes'
  );

export const woodDoorHeightOptions = (): JSX.Element[] =>
  getOptions(
    woodyDoorHeightOptions,
    translations.glassWallDoorProperties,
    'woodyDoorHeightOptions'
  );

export const woodDoorThresholdOptions = (): JSX.Element[] =>
  getOptions(
    woodyDoorThresholdOptions,
    translations.glassWallDoorProperties,
    'woodyThresholdType'
  );

export const woodHingeOptions = (): JSX.Element[] =>
  getOptions(
    woodyHingeTypes,
    translations.glassWallDoorProperties,
    'woodyHingeTypes'
  );

export const thresholdOptions = (): JSX.Element[] =>
  getOptions(
    thresholdTypes,
    translations.glassWallDoorProperties,
    'thresholdTypes'
  );
